// Trailing slash only: search / hash are not part of `pathname`.
const normalizePathname = (pathname: string): string =>
  pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname

export default normalizePathname
